<!--
 * @Description: 
 * @Author: xiawenlong
 * @Date: 2022-11-16 10:14:50
 * @LastEditors: xiawenlong
 * @LastEditTime: 2022-11-16 15:24:25
-->
<template>
  <el-dialog
    class="planRelationDialog"
    title="关联考试计划"
    top="5vh"
    :visible.sync="visible"
    width="620px"
  >
    <table-list
      :data="planList"
      :options="{ border: true, maxHeight: '585px' }"
      :columns="columns(this)"
    ></table-list>
  </el-dialog>
</template>
<script>
// 表格列配置
const columns = () => [
  {
    prop: 'id',
    label: '计划ID',
    minWidth: 140,
  },
  {
    prop: 'examPlanName',
    label: '计划名称',
    minWidth: 320,
    twoLines: true,
  },
]
import { examPaperRelatedPlan } from '@/api/exam'
import to from 'await-to'
import TableList from '@/components/TableList'
export default {
  name: 'AddFormPaper',
  components: { TableList },
  data() {
    return {
      columns,
      visible: false,
      planList: [],
      id: '',
    }
  },
  methods: {
    show(id) {
      this.id = id
      this.visible = true
      this.getPlanList()
    },
    async getPlanList() {
      const [res, err] = await to(examPaperRelatedPlan({ paperId: this.id, size: 500, current: 1 }))
      if (err) return this.$message.warning(err.msg)
      this.planList = res.data
    },
  },
}
</script>
<style lang="scss" scoped>
.planRelationDialog {
  /deep/.el-dialog__body {
    box-sizing: border-box;
    height: 645px;
  }
}
</style>
